var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payments-carousel"},[_c('hot-carousel',{attrs:{"title":_vm.$t('pages.payments.carousel.title'),"body":_vm.$t('pages.payments.carousel.body'),"theme":_vm.$t('pages.payments.carousel.theme'),"component":{
      is: _vm.cardProduct,
      items: _vm.$t('pages.payments.carousel.items'),
    },"swiper-options":_vm.swiperOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }